import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button } from '@bfe/moly';
import { Input, Tabs } from 'antd';
import { FC, lazy, Suspense } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { emailValidateNew } from '@/utils/ruleValidate';

const MobileSelect = lazy(() => import('./MobileSelect'));

const { TabPane } = Tabs;

interface ICompsProps {
  currentKey: string;
  email: string;
  emailChange: (e: any) => void;
  mobile: string;
  mobileChange: (e: any) => void;
  emailErr: boolean;
  mobileErr: boolean;
  disabled: boolean;
  onConfirm: () => void;
  countrySelect: (e: any) => void;
  countryCode: string | undefined;
  defaultCountryCode: string;
  setCountryCode: (code: string) => void;
  setDefaultCountryCode: (code: string) => void;
  onChange: (activeKey: string) => void;
}

const EmailOrMobileUI: FC<ICompsProps> = ({
  currentKey,
  onChange,
  email,
  emailChange,
  mobile,
  mobileChange,
  emailErr,
  mobileErr,
  disabled,
  onConfirm,
  countrySelect,
  countryCode,
  defaultCountryCode,
  setCountryCode,
  setDefaultCountryCode,
}) => {
  const [$t] = useI18nContext();

  // 提示文案content
  const tip = () => {
    return (
      <div className="resetPasswordTip">
        <ExclamationCircleFilled className="tipIcon" />
        <div className="tipContext">{`${$t('Important')} ${$t(
          'withdrawalRestricted.changePassword',
        )}`}</div>
      </div>
    );
  };

  return (
    <div className="emailOrMobileContainer">
      <Tabs defaultActiveKey={currentKey} onChange={onChange}>
        <TabPane tab={$t('Email')} key="1">
          {tip()}
          <div>
            <p className="lebal">{$t('Email')}</p>
            <Input
              autoComplete="off"
              value={email}
              placeholder={$t('Please enter your email address')}
              onChange={emailChange}
            />
            {emailErr && (
              <div className="inputErr">{$t(emailValidateNew(email).msg)}</div>
            )}
          </div>
        </TabPane>
        <TabPane tab={$t('Mobile')} key="2">
          {tip()}
          <div>
            <p className="lebal">{$t('Country')}</p>
            <Suspense>
              <MobileSelect
                countrySelect={countrySelect}
                countryCode={countryCode || ''}
                defaultCountryCode={defaultCountryCode || ''}
                onChangeCountryCode={setCountryCode}
                setDefaultCountryCode={setDefaultCountryCode}
              />
            </Suspense>
          </div>
          <div className="mobileContainer">
            <p className="lebal">{$t('Mobile')}</p>
            <Input
              value={mobile}
              autoComplete="off"
              readOnly={true}
              onFocus={(e: any) => e.target.removeAttribute('readonly')}
              placeholder={$t('Please enter your mobile number')}
              onChange={mobileChange}
            />
            {mobileErr && (
              <div className="inputErr">{$t('Invalid mobile number')}</div>
            )}
          </div>
        </TabPane>
      </Tabs>
      <Button
        variant="primary"
        className="continueBtn"
        style={{ marginTop: 24 }}
        onClick={onConfirm}
        disabled={disabled}
        block
      >
        {$t('Next')}
      </Button>
    </div>
  );
};
export default EmailOrMobileUI;
